module.exports = "/assets/data/f016f37b445c9385c411defa56468378-BN17.data.json";